export const DEFAULT_SHIMEBI = 20
export const DEFAULT_KAISHI = '09:00'
export const DEFAULT_SHURYO = '18:00'
export const DEFAULT_UPLOAD_FILE_MAX_SIZE = 307200
export const SHUGYOU_KEITAI_IPPAN = '1'
export const KYUJITSU_KUBUN_TSUJO = '00'
